import { DepartmentsEnum, SortOrder } from '@moonpig/web-explore-types-graphql'

import { RouterType } from '@moonpig/web-core-routing'
import { removePreAppliedFilters } from './removePreAppliedFilters'
import { SearchStoreState } from '../types'
import {
  ApplicableFilter,
  FilterItem,
  LoadFiltersResponse,
  SearchFilter,
  SearchRequestResponse,
  SearchService,
  SelectedSuggestion,
} from '../../services/types/services'
import { PageType } from '../../types'

type BuildInitialStateArgs = {
  pageTitle: string
  pageType: PageType
  router: RouterType
  department: DepartmentsEnum[]
  initialResponse: SearchRequestResponse
  redirectedDepartment?: DepartmentsEnum
  redirectionSource?: 'smart_redirection' | 'no_results'
  searchTerm: string
  correctedSearchTerm?: string
  selectedSuggestion?: SelectedSuggestion
  promotionId?: string
  initialFiltersResponse: LoadFiltersResponse
  initialFilters: SearchFilter[]
  persistedFilters: string[]
  preAppliedFilters: {
    key: string
    group: string
  }[]
  selectedFilters: ApplicableFilter[]
  hasNbaFilters?: boolean
  hasRudeFilterEnabled?: boolean
  filtersQuery: (filters: SearchFilter[]) => Promise<LoadFiltersResponse>
  services: SearchService
  allFilters: FilterItem[]
}

export function buildInitialState({
  pageTitle,
  pageType,
  router,
  department,
  initialResponse,
  redirectedDepartment,
  redirectionSource,
  searchTerm,
  correctedSearchTerm,
  selectedSuggestion,
  promotionId,
  preAppliedFilters,
  selectedFilters,
  hasNbaFilters,
  hasRudeFilterEnabled,
  filtersQuery,
  services,
  allFilters,
}: BuildInitialStateArgs): Partial<SearchStoreState> {
  return {
    pageContext: {
      title: pageTitle,
      type: pageType,
      router,
    },
    searchContext: {
      departments: department,
      departmentCounts: initialResponse.departments,
      redirectedDepartment,
      redirectionSource,
      searchTerm,
      correctedSearchTerm,
      selectedSuggestion,
      promotionId,
    },
    filters: allFilters,
    preAppliedFilters,
    selectedFilters,
    queryFilters: async filters => {
      const result = await filtersQuery(filters)
      return removePreAppliedFilters(result.filters, preAppliedFilters)
    },
    sortValue: SortOrder.POPULARITY,
    initialSortValue: SortOrder.POPULARITY,
    results: initialResponse,
    hasNbaFilters,
    hasRudeProducts: hasRudeFilterEnabled,
    initialOffset: 0,
    querySearch: async ({
      newPage,
      filters,
      sortOrder,
    }: {
      newPage: number
      filters: SearchFilter[]
      sortOrder: SortOrder | undefined
    }) => {
      const searchResponse = await services.search({
        searchTerm,
        departments: department,
        sortOrder,
        filters,
        page: newPage,
        promotionId,
        sponsoredProducts: [],
      })
      return searchResponse
    },
    topPage: initialResponse.page,
    bottomPage: initialResponse.page,
    lastLoadedPage: initialResponse.page,
    filtersMenuOpen: false,
    loading: false,
  }
}
